import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  instructors: [],
};

const slice = createSlice({
  name: "emails",
  initialState,

  reducers: {
    setInstructorsEmail: (state, action) => {
      state.instructors = action.payload;
    },
    resetInstructorsEmail: (state) => {
      state = initialState;
    },
  },
});

export const { setInstructorsEmail, resetInstructorsEmail } = slice.actions;
export default slice.reducer;
